export default async function home (state, appOptions, lastPage) {
  const Home = (await import(/* webpackChunkName: 'pollev-home' */ '../../participant-components/home')).default

  return new Home({ state, lastPage })
}
